import {useLocation, useParams} from "react-router-dom";
import {WorkflowType} from "../../utils/enums";

export type PreflightRouteParams = Readonly<{
  facilityId: string;
  admissionId?: string;
}>;

/** Optional search params when starting a new preflight from Start Workflow. */
export type StartPreflightSearchParams = Readonly<{
  /** TODO: consumed by preflight once create-admission API accepts workflow type. */
  workflowType?: string;
  /** Pre-selects resident for linking when starting from Start Workflow. */
  residentId?: string;
}>;

export const createPreflightUrl = ({
  facilityId,
  admissionId = "",
  workflowType,
  residentId,
}: PreflightRouteParams & StartPreflightSearchParams): string => {
  const path = `/admin/facility/${facilityId}/workflows/${admissionId}`;
  const params = new URLSearchParams();

  if (workflowType) {
    params.set("workflow_type", workflowType.toLowerCase());
  }

  if (residentId) {
    params.set("residentId", residentId);
  }

  const query = params.toString();
  return query ? `${path}?${query}` : path;
};

export const usePreflightRouteParams = () => useParams<PreflightRouteParams>();

export const usePreflightWorkflowParam = (): string => {
  const {search} = useLocation();
  const params = new URLSearchParams(search);
  const value =
    params.get("workflow_type") ??
    params.get("workflowType") ??
    WorkflowType.ADMISSION;
  return value.toLowerCase();
};

export const usePreflightResidentIdParam = (): string | undefined => {
  const {search} = useLocation();
  const residentId = new URLSearchParams(search).get("residentId");
  return residentId ?? undefined;
};
